// extracted by mini-css-extract-plugin
export default {"container":"CloudStorageUploader_container__E8iT8","upload":"CloudStorageUploader_upload__BYyEf"};